<template>
    <v-container fluid>
        <v-dialog v-model="customize" width="auto" max-width="700">
            <v-card>
                <v-card-title>{{$t('GlobalSettingsPage.customized-financial-files')}}</v-card-title>
                <v-card-text class="pt-3">
                    <bee-handy-smart-table
                    v-model="customizedFinancialFileTemplate"
                    ref="settingTable"
                    :items="customizedFinancialFiles"
                    :headers="headers"
                    :items-per-page="-1"
                    :data-table-props="{ disableSort: true }"
                    :show-add-row="true"
                    :editable-rows="true"
                    :loading="tableLoading"
                    :disable-input-fields="tableLoading"
                    dense
                    zebra
                    hide-default-footer
                    hide-inputs-details
                    disable-validation-fields
                    @keydown.enter="addCustomizedFinancialFile(settingId)"
                    >
                        <template v-slot:input.financial_file_id="{attr,on}">
                            <v-autocomplete
                                v-on="on"
                                v-bind="attr" 
                                :items="financialFiles.filter(v => !customizedFinancialFiles.find(t => t.financial_file_id === v.id))"
                                item-text="company_name"
                                item-value="id"
                                :rules="[v => !!v]"
                            ></v-autocomplete>
                        </template>
                        <template v-slot:input.setting_value="{attr,on}">
                            <div class="d-flex h-100 justify-center align-center">
                                <v-autocomplete
                                    v-if="tableType === valueTypes.integer"
                                    v-on="on"
                                    v-bind="attr"
                                    :items="postingPriorityTypeValues"
                                    item-text="name"
                                    item-value="value"
                                    :rules="[v => !!v]"

                                />
                                <v-checkbox
                                class="mt-2"
                                    v-if="tableType === valueTypes.boolean"
                                    v-model="customizedFinancialFileTemplate.setting_value"
                                    v-on="on"
                                    v-bind="attr"
                                    :true-value="true"
                                    :false-value="false"
                                />
                            </div>
                        </template>
                        <template v-if="tableType === valueTypes.boolean" v-slot:item.setting_value="{item}">
                            <div class="d-flex justify-center align-center">
                                <v-checkbox class="mb-2" v-model="item.setting_value" dense  readonly  :ripple="false" hide-details></v-checkbox>
                            </div>
                        </template>
                        <template v-slot:input.note="{attr,on}">
                            <v-text-field v-on="on" v-bind="attr"></v-text-field>
                        </template>
                        <template v-slot:no-input.actions>
                            <div class="d-flex justify-center">
                                <tooltip :text="$t('buttons.add')" top>
                                    <v-btn
                                        icon
                                        small
                                        color="greenDarken1"
                                        @click="addCustomizedFinancialFile(settingId)"
                                    >
                                        <v-icon>
                                            mdi-check-circle-outline
                                        </v-icon>
                                    </v-btn>
                                </tooltip>
                            </div>
                        </template>
                        <template v-slot:item.actions="{ index }">
                            <div class="d-flex justify-center">
                                <v-btn
                                    icon
                                    small
                                    color="warning-color"
                                    @click="() => {
                                        $refs.settingTable.activeEditForRow(index); 
                                    }"
                                >
                                    <v-icon>
                                        mdi-pencil
                                    </v-icon>
                                </v-btn> 

                                <v-btn
                                    icon
                                    small
                                    color="deletingColor"
                                    @click="deleteCustomizedFinancialFile(settingId, index)"
                                >
                                    <v-icon>
                                        mdi-delete
                                    </v-icon>
                                </v-btn>  
                            </div>
                            
                        </template>
                    </bee-handy-smart-table>
                </v-card-text>
                <v-card-actions>
                    <v-btn
                    color="success"
                    @click="customize = false;  resetTableInputs()"
                     text>
                        {{ $t('buttons.ok') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-row>           
            <v-col cols="12" sm="6" xs="6" md="12" lg="3">
                <slot name="breadcrumbs" class="py-4"></slot>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="6" lg="4" v-for="setting in settings" :key="setting.id">
                <v-card v-if="setting.type === valueTypes.integer" class="rounded-lg" height="100%">
                    <v-card-title class="pb-0 pt-2 d-flex ">
                        <v-row class="justify-space-between">
                            <v-col class="setting-title px-2 text-h6 d-flex">
                                <div v-html="$t('GlobalSettingsPage.' + setting.setting_key + '.icon')"></div>
                                <p class="my-0 mx-1" style="white-space: normal; word-break: normal; overflow-wrap: break-word;">{{ $t('GlobalSettingsPage.' + setting.setting_key + '.title') }}</p>
                            </v-col>
                            <v-col cols="auto" class="px-2">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-badge
                                            offset-x="14"
                                            offset-y="20"
                                            bordered
                                            :content="setting?.financial_file_settings_responses?.length"
                                            :value="setting?.financial_file_settings_responses?.length"
                                        >
                                            <v-btn
                                                v-bind="attrs"
                                                v-on="on"
                                                class="pa-0"
                                                @click="showCustomizeFinancialFilesDialog(setting)"
                                                transparent
                                                depressed
                                                small
                                                color="white"
                                            >
                                                <i class="fas fa-sliders-h fa-2x"></i>
                                            </v-btn>
                                        </v-badge>
                                    </template>
                                    <span>{{ $t('GlobalSettingsPage.customize-financial-files') }}</span>
                                </v-tooltip>
                            </v-col>
                        </v-row>
                    </v-card-title>
                    <v-card-text class="pt-1 pb-2">
                        <v-row>
                            <v-col>
                                <p class="description"></p>
                            </v-col>
                            <v-col cols="5">
                                <v-autocomplete
                                    v-model="setting.setting_value"
                                    @change="changeSettingValue(setting)"
                                    dense
                                    solo
                                    :items="postingPriorityTypeValues"
                                    item-text="name"
                                    item-value="value"
                                    :style="'cursor:pointer;'"
                                    :hide-details="true"
                                ></v-autocomplete>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
                <v-card v-if="setting.type === valueTypes.boolean" class="rounded-lg" height="100%">
                    <v-card-title class="d-flex pb-0 pt-2">
                        <v-row class="justify-space-between">
                            <v-col class="setting-title px-2 text-h6 d-flex">
                                <div v-html="$t('GlobalSettingsPage.' + setting.setting_key + '.icon')"></div>
                                <p class="my-0 mx-1" style="white-space: normal; word-break: normal; overflow-wrap: break-word;">{{ $t('GlobalSettingsPage.' + setting.setting_key + '.title') }}</p>
                            </v-col>
                            <v-col cols="auto" class="px-2">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-badge
                                            offset-x="14"
                                            offset-y="20"
                                            bordered
                                            :content="setting?.financial_file_settings_responses?.length"
                                            :value="setting?.financial_file_settings_responses?.length"
                                        >
                                            <v-btn
                                                v-bind="attrs"
                                                v-on="on"
                                                class="pa-0"
                                                @click="showCustomizeFinancialFilesDialog(setting)"
                                                transparent
                                                depressed
                                                small
                                                color="white"
                                            >
                                                <i class="fas fa-sliders-h fa-2x"></i>
                                            </v-btn>
                                        </v-badge>
                                    </template>
                                    <span>{{ $t('GlobalSettingsPage.customize-financial-files') }}</span>
                                  </v-tooltip>
                            </v-col>
                        </v-row>
                    </v-card-title>
                    <v-card-text class="pt-0 pb-2">
                        <v-row class="justify-space-between">
                            <div>
                                <p class="description"></p>
                            </div>
                            <v-col cols="auto" class="px-2">
                                <v-switch
                                    v-model="setting.setting_value"
                                    readonly
                                    inset
                                    @click="changeSettingValue(setting)"
                                />
                            </v-col>
                        </v-row>
                        <v-row>

                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
  
    </v-container>
</template>
<script>
import {mapState, mapGetters} from 'vuex'
import eventBus from '@/event-bus'
import {postingPriorityTypeValues, valueTypes} from '@/helpers/enums'
export default {
    data () {
        return {
            value : '0',
            show: true,
            itemValue: null,
            customize: false,
            id: null,
            postingPriorityTypeValues,
            settingName:null,
            settings: [],
            settingValue: null,
            customizedFinancialFileTemplate: {
            },
            rowId : null,
            valueTypes,
            tableLoading: true,
            t: true,
            tableType:false,
            settingId : null,
            customizedFinancialFiles: []
        }
    },
    watch: {
    },
    computed: {
        ...mapState({
            financialFiles: state => state.financialFiles.financial_files
        }),
        ...mapGetters({
            getFinancialFileById: 'financialFiles/getFinancialFileById',
            getGlobalSettingById: 'settings/getGlobalSettingById'
        }),
        headers() {
            let headers = [
                {
                    name: 'financial_file_id',
                    text: this.$t('financial-file'),
                    value: 'financial_file_id',
                    width: '30%',
                    setValueExpr: id => this.getFinancialFileById(id)?.company_name
                },
                this.tableType === valueTypes.integer ?    {
                    name: 'setting_value',
                    text: this.settingName,
                    value: 'setting_value',
                    setValueExpr: value => postingPriorityTypeValues.find(v => (value === '-' || value === v.value))?.name
                }
                : this.tableType === valueTypes.boolean ? {
                    name: 'setting_value',
                    text: this.settingName,
                    value: 'setting_value',
                    type: 'boolean',
                } : null,
                {
                    name: 'note',
                    text: this.$t('inputs.notes'),
                    value :'note',
                    width:'20%'

                },
                {
                    name: 'actions',
                    noInput:true,
                    text: '',
                    value: '',
                    width: '80'
                }
            ]
            return  headers.filter(c => Boolean(c) );
        },
    },
    methods: {
        addCustomizedFinancialFile(settingId) {
            const setting = JSON.parse(JSON.stringify(this.getGlobalSettingById(settingId)));
            if(this.customizedFinancialFileTemplate.financial_file_id && ((this.customizedFinancialFileTemplate.setting_value || this.customizedFinancialFileTemplate.setting_value === 0 || this.customizedFinancialFileTemplate.setting_value === false )|| this.tableType === valueTypes.boolean) )
            {
                this.tableLoading = true;
                let financialFileId = setting.financial_file_settings_responses.findIndex(v => v.financial_file_id === this.customizedFinancialFileTemplate.financial_file_id)
                financialFileId !== -1 
                    ?setting.financial_file_settings_responses[financialFileId] = this.customizedFinancialFileTemplate
                    :setting.financial_file_settings_responses.push(this.customizedFinancialFileTemplate)
                this.$store.dispatch('settings/updateGlobalSettings', this.updateSettingPayload(setting)).then(() => {
                    this.getGlobalSetting();
                })
            }
        },
        showCustomizeFinancialFilesDialog(setting) {
            this.customizedFinancialFiles = setting.financial_file_settings_responses;
            this.customize = true;
            this.settingName =  this.$t('GlobalSettingsPage.' + setting.setting_key + '.title');
            this.tableType = setting.type;
            this.settingId = setting.id;
        },
        changeSettingValue(setting) {
            const updateSetting = {...setting};
            if(updateSetting.type === valueTypes.boolean){
                updateSetting.setting_value = !updateSetting.setting_value;
            }
            this.$store.dispatch('settings/updateGlobalSettings', this.updateSettingPayload(updateSetting)).then( () =>{
                this.getGlobalSetting();
            })
        },
        getGlobalSetting () {
            this.$store.dispatch('settings/fetchGlobalSettings').then(data => {
                this.settings = data.filter(v => v.is_active);
                this.customizedFinancialFiles = this.getGlobalSettingById(this.settingId)?.financial_file_settings_responses;
                eventBus.$emit('notification',this.$t('notifications.change-setting-alert'))
                this.$refs.settingTable.resetInputs();
                this.$refs.settingTable.resetEdit()
            }).finally(() => {
                this.tableLoading = false
            })
        },
        deleteCustomizedFinancialFile(settingId, index) {
            this.tableLoading = true;
            const setting = JSON.parse(JSON.stringify(this.getGlobalSettingById(settingId)));
            setting.financial_file_settings_responses.splice(index,1);
            this.$store.dispatch('settings/updateGlobalSettings', this.updateSettingPayload(setting)).then(() => {
                this.getGlobalSetting();
            })
        },
        updateSettingPayload(data) {
            const setting = {
                setting_key: data.setting_key,
                setting_value: data.setting_value,
                type: data.type,
                descriptions: data.description,
                using_financial_file: data.using_financial_file,
                is_active: data.is_active,
                financial_file_settings_requests: data.financial_file_settings_responses
            }
            const id = data.id;
            return {
                setting,
                id
            }
        },
        resetTableInputs() {
            this.$refs.settingTable.resetEdit()
            this.customizedFinancialFileTemplate = {
                financial_file_id: null,
                setting_value: null,
                note: null
            }
        }
    },
    mounted() {
        const promises = []
        !this.settings.length? promises.push(this.$store.dispatch('settings/fetchGlobalSettings').then(data => {
            this.settings = data.filter(v => v.is_active);
        })): null
        !this.financialFiles.length? promises.push(this.$store.dispatch("financialFiles/fetchAll", {})):null
        Promise.all(promises).then(() => {
            this.tableLoading = false;
        })
    }
}
</script>